import { FilterInputService } from "../../filter/Services/filterInputService";
import { ISearchRequest } from "../dto/requestBody.dto";



export class SearchInputService extends FilterInputService {

  public override requestBody: ISearchRequest;

  override async getActiveFilters() {
    this.setFilters();

    if (this.requestBody) {
      this.requestBody.filters = this.currentFilters;
    }

    try {
      return await this.$apiService.postFilter<IActiveFilters>('/websitesearch/update', this.requestBody, false)
      .then((response) => {
        if (response) {
           return response?.data;
        } else {
          throw Error();
        }
      }).catch((error) => {
        throw Error(error);
      });
    } catch(error) {
      this.$log.error('productfilter/update Error: ', error);
      return null;
    }
  }
}
